import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceTemplate.css';

function NotAboutTheFall() {
  return (
    <div className="service-page">
      <section className="service-hero" style={{backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(https://customer-assets.emergentagent.com/job_fitlaunch/artifacts/fx48aw9v_web%202.jpeg)`}}>
        <div className="container">
          <h1>It's Not About the Fall, It's About the Bounce</h1>
          <p style={{color: '#FF6B35', fontSize: '1.1em', marginBottom: '10px', fontWeight: '500', fontStyle: 'italic'}}>Born from lived experience, built on psychology, driven by passion</p>
          <p className="subtitle" style={{whiteSpace: 'nowrap'}}>Jason's powerful keynote presentation - a unique story that is both harrowing and uplifting</p>
        </div>
      </section>

      {/* White section with F-IT logo repeating pattern */}
      <div style={{
        width: '100%', 
        padding: '60px 20px', 
        position: 'relative',
        background: `
          linear-gradient(rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.95)),
          url(/fit-logo.jpg)
        `,
        backgroundSize: 'auto, 100px 100px',
        backgroundRepeat: 'no-repeat, repeat',
        backgroundPosition: '0 0, 0 0'
      }}>
        <div style={{maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>A Story Always Evolving</h2>
          <p>When Jason started speaking in 2009, he told a work at height story mainly for the construction industry - it was a stereotypical "don't be like me" story. Over the last 8 years, he's been speaking about how his poor wellbeing affected his safety choices on that day in&nbsp;1993.</p>
          <p>Today, Jason's good wellbeing has changed his life, and so his presentation today is "be like me" - because if he had this positive mindset back in 1993, he would have spoken up about his safety concerns and his accident wouldn't have&nbsp;happened.</p>
          <p style={{marginBottom: 0}}>This unique story is both harrowing and uplifting and covers Wellbeing, Health & Safety - showing how they influence one another, either positively or negatively.</p>
        </div>
      </div>

      {/* Grey section - The Fall */}
      <div style={{backgroundColor: '#f9f9f9', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>The Fall</h2>
          <p>Jason openly talks about his workplace accident and the effect this had on himself, family, friends and work colleagues. But he now also explores and discusses why he made that decision on the day of his accident and how his own health and wellbeing in the months that led up to his accident also played a big part in that safety&nbsp;decision.</p>
        </div>
      </div>

      {/* White section - The Bounce */}
      <div style={{width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>The Bounce</h2>
          <p>This part of the talk covers Jason's recovery from his mental health crisis. He talks about how some simple changes he made in his day to day life has had a positive impact on his wellbeing and then he discovered the resilience to start thriving in all aspects of his life, after just coping with anxiety, stress and mental health issues for nearly a quarter of a&nbsp;century.</p>
        </div>
      </div>

      {/* Grey section - Impact & Recognition */}
      <div style={{backgroundColor: '#f2f2f2', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Impact & Recognition</h2>
          
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '40px'}}>
            <div style={{backgroundColor: '#fff', padding: '30px', borderRadius: '8px', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
              <h3 style={{fontSize: '48px', color: '#FF6B35', marginBottom: '10px'}}>4,000+</h3>
              <p style={{fontSize: '18px', color: '#2c3e50', margin: 0}}>Presentations Delivered</p>
            </div>
            <div style={{backgroundColor: '#fff', padding: '30px', borderRadius: '8px', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
              <h3 style={{fontSize: '36px', color: '#FF6B35', marginBottom: '10px'}}>Global Reach</h3>
              <p style={{fontSize: '16px', color: '#2c3e50', margin: 0}}>UK & Ireland, Europe, Middle East (Saudi Arabia, Abu Dhabi, Dubai), and the United States</p>
            </div>
          </div>
          
          <h3 style={{fontSize: '28px', color: '#2c3e50', marginBottom: '15px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Awards & Recognition</h3>
          <ul>
            <li><strong>2025</strong> - British Safety Council Lifetime Achievement Award</li>
            <li><strong>2024</strong> - Honorary NEBOSH National Diploma</li>
            <li><strong>2017</strong> - ROSPA Archangel Award</li>
            <li><strong>2015</strong> - MBE for Health & Safety Services to the Construction Industry</li>
            <li>Amongst many others...</li>
          </ul>
        </div>
      </div>

      {/* White section - What's Included */}
      <div style={{width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>What's Included</h2>
          <ul>
            <li>60 minute keynote presentation (customisable to your needs)</li>
            <li>Jason's personal story and the birth of F-IT Score</li>
            <li>Introduction to the F-IT 0-10 scale</li>
            <li>Interactive Q&A session</li>
            <li>Powerful insights into wellbeing and safety connection</li>
            <li>Follow-up resources for your leadership team</li>
          </ul>
        </div>
      </div>

      {/* Grey section - Perfect For */}
      <div style={{backgroundColor: '#ebebeb', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Perfect For</h2>
          <ul>
            <li>Leadership teams looking for cultural transformation</li>
            <li>Safety conferences and industry events</li>
            <li>Wellbeing and mental health awareness campaigns</li>
            <li>Organisational kickoff sessions</li>
            <li>Board presentations and strategic planning</li>
          </ul>
        </div>
      </div>

      {/* White section - See Jason in Action */}
      <div style={{width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>See Jason in Action</h2>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px'}}>
            <img src="https://customer-assets.emergentagent.com/job_fitlaunch/artifacts/6x36r8ff_JAnker%20web.jpg" alt="Jason engaging with audience" style={{width: '100%', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}} />
            <img src="https://customer-assets.emergentagent.com/job_fitlaunch/artifacts/856ilbns_jason%20web%201.jpg" alt="Jason presenting on stage" style={{width: '100%', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}} />
          </div>
        </div>
      </div>

      {/* Grey section - Testimonials */}
      <div style={{backgroundColor: '#f2f2f2', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '30px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>What People Say</h2>
          
          <div style={{display: 'grid', gap: '30px'}}>
            <div style={{backgroundColor: '#fff', padding: '30px', borderRadius: '8px', borderLeft: '5px solid #FF6B35', boxShadow: '0 2px 10px rgba(0,0,0,0.05)'}}>
              <p style={{fontSize: '16px', fontStyle: 'italic', marginBottom: '15px', lineHeight: '1.7'}}>"Jason's presentation is more powerful than any I can ever make and the message is very simple - every single one of us has a choice to make about being safe – or unsafe - at work; and we bear responsibility for the consequences."</p>
              <p style={{fontWeight: 'bold', color: '#FF6B35', margin: 0}}>— Dame Judith Hackitt</p>
            </div>

            <div style={{backgroundColor: '#fff', padding: '30px', borderRadius: '8px', borderLeft: '5px solid #FF6B35', boxShadow: '0 2px 10px rgba(0,0,0,0.05)'}}>
              <p style={{fontSize: '16px', fontStyle: 'italic', marginBottom: '15px', lineHeight: '1.7'}}>"Jason is well known in the H&S world, his talk is a non-holds barred account of his accident. His candid yet humorous way of taking the audience on his journey is engaging yet the seriousness of the message is never lost. Very few speakers talk like Jason, too often the talk focuses on the accident & resulting injuries but Jason takes you on a very different journey into emotional wellbeing & the effect it had & still has on his family. The Ripple-effect, this is something that really resonated with our audiences. People are still talking about this now, it has landed that hard!"</p>
              <p style={{fontWeight: 'bold', color: '#FF6B35', margin: 0}}>— Neil Fisher, Network Rail</p>
            </div>

            <div style={{backgroundColor: '#fff', padding: '30px', borderRadius: '8px', borderLeft: '5px solid #FF6B35', boxShadow: '0 2px 10px rgba(0,0,0,0.05)'}}>
              <p style={{fontSize: '16px', fontStyle: 'italic', marginBottom: '15px', lineHeight: '1.7'}}>"Throughout 2023 we rolled out a working at height campaign within BAE systems Naval Ships and Jason Anker and P2BS were vital in accomplishing this. Jason delivered a powerful presentation to roughly 2,000 people across both of our Glasgow sites over 15 dates. It was a successful roll out to the workforce with a real hard hitting message surrounding safety as well as the importance of self care. I would highly recommend Jason, Sean and P2BS's services to anyone."</p>
              <p style={{fontWeight: 'bold', color: '#FF6B35', margin: 0}}>— Jonathan Macpherson, BAE Systems – Naval Ships</p>
            </div>

            <div style={{backgroundColor: '#fff', padding: '30px', borderRadius: '8px', borderLeft: '5px solid #FF6B35', boxShadow: '0 2px 10px rgba(0,0,0,0.05)'}}>
              <p style={{fontSize: '16px', fontStyle: 'italic', marginBottom: '15px', lineHeight: '1.7'}}>"The big difference is Jason finishes his story and session in a very positive way that really made me think about ME, my wellbeing and my impact on others. This is a story of an ordinary bloke told in an extraordinary way that makes a real impact on his audience and at an individual level."</p>
              <p style={{fontWeight: 'bold', color: '#FF6B35', margin: 0}}>— Chris Bramley, Bakkavor Salads</p>
            </div>
          </div>
        </div>
      </div>

      {/* White section - Additional Impact */}
      <div style={{width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Additional Impact</h2>
          <p>Sean Toon, one of Jason's close friends, will be available on the day to speak about the impact the accident had on his circle of&nbsp;friends.</p>
          <p><em>*Additional fee of £150</em></p>
        </div>
      </div>

      {/* Pricing section */}
      <div style={{backgroundColor: '#f9f9f9', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '800px', margin: '0 auto', backgroundColor: '#fff', padding: '40px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
          <h3 style={{fontSize: '28px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Investment</h3>
          <p><strong>Duration:</strong> 60 minutes plus Q&A</p>
          <p><strong>Price:</strong> From £2,950</p>
          <p style={{marginBottom: 0}}><em>Includes pre-event consultation and customised content to your organisation's needs</em></p>
        </div>
      </div>

      <section className="cta-section">
        <div className="container">
          <h2>Ready to Book Jason's Keynote?</h2>
          <p>Transform how your organisation thinks about wellbeing and&nbsp;safety</p>
          <div style={{display: 'flex', gap: '30px', justifyContent: 'center', flexWrap: 'wrap', marginTop: '30px'}}>
            <div style={{backgroundColor: 'rgba(255,255,255,0.1)', padding: '25px', borderRadius: '8px', textAlign: 'center', minWidth: '250px'}}>
              <h3 style={{color: '#FF6B35', marginBottom: '10px'}}>Request a Booking</h3>
              <p style={{fontSize: '14px', marginBottom: '15px'}}>Check availability for your event or conference</p>
              <Link to="/contact" className="cta-btn cta-btn-primary">Get In Touch</Link>
            </div>
            <div style={{backgroundColor: 'rgba(255,255,255,0.1)', padding: '25px', borderRadius: '8px', textAlign: 'center', minWidth: '250px'}}>
              <h3 style={{color: '#FF6B35', marginBottom: '10px'}}>Explore Services</h3>
              <p style={{fontSize: '14px', marginBottom: '15px'}}>See our full range of workshops and training</p>
              <Link to="/how-it-works" className="cta-btn cta-btn-secondary">View All Services</Link>
            </div>
          </div>
          <div style={{marginTop: '30px', fontSize: '15px'}}>
            <p style={{margin: '5px 0'}}>01636 550190 option 5 <span style={{fontSize: '13px', opacity: '0.8'}}>(Mon-Fri 9am-5pm)</span></p>
            <p style={{margin: '5px 0'}}>hello@f-itscore.com</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default NotAboutTheFall;
